var _excluded = ["show", "onDelete", "toggle", "text"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from "../../../core/components";
var DeleteModal = function DeleteModal(_ref) {
  var show = _ref.show,
    onDelete = _ref.onDelete,
    toggle = _ref.toggle,
    text = _ref.text,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Modal, Object.assign({
    isOpen: show,
    toggle: toggle,
    zIndex: 21800000000
  }, otherProps), /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggle,
    charcode: "x",
    tag: "h4"
  }, "Confirm Delete"), /*#__PURE__*/React.createElement(ModalBody, null, text ? text : 'Are you sure you want to delete this item?'), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: toggle,
    disabled: otherProps.submitting
  }, "Cancel"), ' ', /*#__PURE__*/React.createElement(Button, {
    color: "danger",
    onClick: onDelete,
    withLoader: true,
    loading: otherProps.submitting,
    loaderText: "Deleting",
    disabled: otherProps.submitting
  }, "Delete")));
};
DeleteModal.defaultProps = {
  text: '',
  toggle: undefined
};
export default DeleteModal;